(function () {
    'use strict';

    angular.module("imApp").factory("furnitureFabricsMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 2116,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
